/**
 * Match Detail Auto Refresh
 * Refreshes odds, banner score, timeline events and statistics.
 *
 * - Prematch / finished: every 60 s (odds only)
 * - Live: every 15 s (odds + score + timeline + statistics)
 * - Pauses when tab is hidden; resumes immediately when visible.
 *
 * Requires: window.matchOddsRefresh = { ajaxUrl, nonce, fixtureId, apiFixtureId }
 * Requires: jQuery
 */
(function ($) {
    'use strict';

    var LIVE_STATUSES = ['LIVE', '1H', '2H', 'HT', 'ET', 'PEN'];
    var INTERVAL_LIVE = 15000;   // 15 s
    var INTERVAL_DEFAULT = 60000; // 60 s

    // ───────────────────────────── Helpers ─────────────────────────────

    function getArrowHtml(trend) {
        if (trend === 'up') return '<span class="arrow-up">▲</span>';
        if (trend === 'down') return '<span class="arrow-down">▼</span>';
        return '';
    }

    function isLiveStatus(status) {
        return LIVE_STATUSES.indexOf(status) !== -1;
    }

    // ───────────────────────── Odds updater ────────────────────────────

    function updateCellWithIndicator($cell, value, indicator, isHome) {
        var arrow = getArrowHtml(indicator || '');
        var cls = isHome ? 'cell-value text-green-600' : 'cell-value text-blue-600';
        var valHtml = '<span class="' + cls + '">' + (value || '–') + '</span>';
        $cell.html(isHome ? arrow + valHtml : valHtml + arrow);
    }

    function updateOddsDisplay(oddsData) {
        var $table = $('#match-odds-table');
        if (!$table.length) return;

        if (!oddsData || !oddsData.has_odds || !oddsData.rows || !oddsData.rows[0]) {
            $table.find('#match-odds-content').hide();
            if (!$table.find('#match-odds-empty').length) {
                $table.append('<div class="odds-empty" id="match-odds-empty"><p>Chưa có dữ liệu tỷ lệ cược cho trận đấu này.</p></div>');
            }
            $table.find('#match-odds-empty').show();
            return;
        }

        var row = oddsData.rows[0];
        var ah = row.asian_handicap || {};
        var eu = row.european || {};
        var ou = row.over_under || {};
        var cr = row.corners || {};

        $table.find('#match-odds-empty').hide();
        var $c = $table.find('#match-odds-content');
        $c.show();
        if (!$c.length) return;

        // Asian Handicap
        var $ahH = $table.find('[data-odds="asian-home"]');
        if ($ahH.length) updateCellWithIndicator($ahH, ah.home, (ah.change_indicators || {}).home, true);
        $table.find('[data-odds="asian-handicap"]').text(ah.handicap || '–');
        var $ahA = $table.find('[data-odds="asian-away"]');
        if ($ahA.length) updateCellWithIndicator($ahA, ah.away, (ah.change_indicators || {}).away, false);

        // European
        var $euH = $table.find('[data-odds="european-home"]');
        if ($euH.length) updateCellWithIndicator($euH, eu.home, (eu.change_indicators || {}).home, true);
        $table.find('[data-odds="european-draw"]').text(eu.draw || '–');
        var $euA = $table.find('[data-odds="european-away"]');
        if ($euA.length) updateCellWithIndicator($euA, eu.away, (eu.change_indicators || {}).away, false);

        // Over / Under
        var $ouO = $table.find('[data-odds="overunder-over"]');
        if ($ouO.length) updateCellWithIndicator($ouO, ou.over, (ou.change_indicators || {}).over, true);
        $table.find('[data-odds="overunder-line"]').text(ou.line || '–');
        var $ouU = $table.find('[data-odds="overunder-under"]');
        if ($ouU.length) updateCellWithIndicator($ouU, ou.under, (ou.change_indicators || {}).under, false);

        // Corners
        var $crO = $table.find('[data-odds="corners-over"]');
        if ($crO.length) updateCellWithIndicator($crO, cr.over, (cr.change_indicators || {}).over, true);
        $table.find('[data-odds="corners-line"]').text(cr.line || '–');
        var $crU = $table.find('[data-odds="corners-under"]');
        if ($crU.length) updateCellWithIndicator($crU, cr.under, (cr.change_indicators || {}).under, false);
    }

    // ──────────────────────── Banner updater ───────────────────────────

    function updateBanner(bannerData) {
        if (!bannerData) return;

        var $mid = $('.banner-match__container-mid');
        if (!$mid.length) return;

        var isLive = bannerData.is_live;
        var isFinished = bannerData.is_finished;

        if (isLive || isFinished) {
            // Show score — replace whatever is inside .container-mid
            var goalsHome = bannerData.goals_home != null ? bannerData.goals_home : 0;
            var goalsAway = bannerData.goals_away != null ? bannerData.goals_away : 0;

            // Only update if content differs (avoid flicker)
            var $scores = $mid.find('.match-info__score');
            if ($scores.length === 3) {
                // Already in score mode — just update numbers
                $scores.eq(0).text(goalsHome);
                $scores.eq(2).text(goalsAway);
            } else {
                // Switch from time mode → score mode
                $mid.html(
                    '<span class="match-info__score">' + goalsHome + '</span>' +
                    '<span class="match-info__score">-</span>' +
                    '<span class="match-info__score">' + goalsAway + '</span>'
                );
            }
        }

        // Update wrapper data attribute so interval logic stays correct
        var $page = $('#match-detail-page');
        if ($page.length) {
            $page.attr('data-match-status', bannerData.status || 'NS');
            $page.attr('data-is-live', isLive ? '1' : '0');
        }
    }

    // ─────────────────────── Timeline updater ──────────────────────────

    function buildEventHtml(evt) {
        var minute = evt.minute || '';
        var desc = evt.description || '';
        var isHome = !!evt.is_home;

        if (isHome) {
            return '<div class="timeline-event">' +
                '<div class="timeline-event-item"><div class="timeline-left timeline-group"><span class="timeline-desc">' + escHtml(desc) + '</span></div></div>' +
                '<div class="timeline-line-center"><div class="timeline-icon-circle"></div><div class="timeline-minute minute-home">' + escHtml(minute) + '</div></div>' +
                '<div class="timeline-event-item item-right"></div>' +
            '</div>';
        }
        return '<div class="timeline-event">' +
            '<div class="timeline-event-item item-left"></div>' +
            '<div class="timeline-line-center"><div class="timeline-icon-circle"></div><div class="timeline-minute minute-away">' + escHtml(minute) + '</div></div>' +
            '<div class="timeline-event-item"><div class="timeline-right timeline-group"><span class="timeline-desc">' + escHtml(desc) + '</span></div></div>' +
        '</div>';
    }

    function escHtml(str) {
        var div = document.createElement('div');
        div.appendChild(document.createTextNode(str));
        return div.innerHTML;
    }

    function updateTimeline(timelineData) {
        if (!timelineData) return;

        var $container = $('.match-timeline-container__timeline');
        if (!$container.length) return;

        var $events = $container.find('.timeline-events');
        if (!$events.length) return;

        var events = timelineData.events || [];
        var hasEvents = timelineData.has_events && events.length > 0;

        if (!hasEvents) {
            // Keep the existing empty state if no events yet
            return;
        }

        // Ensure vertical line exists
        if (!$container.find('.timeline-vertical-line').length) {
            $container.prepend('<div class="timeline-vertical-line"></div>');
        }

        // Rebuild events list
        var html = '';
        for (var i = 0; i < events.length; i++) {
            html += buildEventHtml(events[i]);
        }
        $events.html(html);
    }

    // ──────────────────────── Statistics updater ────────────────────────

    function updateStatistics(statsData) {
        if (!statsData) return;

        var $section = $('.statistical-section');
        if (!$section.length) return;

        var $container = $section.find('.statistical-container');
        if (!$container.length) return;

        if (!statsData.has_stats || !statsData.rows || statsData.rows.length === 0) {
            return; // keep existing empty state
        }

        // Remove empty state if it exists
        $container.find('.statistical-empty').remove();

        var $content = $container.find('.statistical-content');
        if (!$content.length) {
            // Create content container with header
            var headerHtml =
                '<div class="statistical-content">' +
                    '<div class="statistical-content__header">' +
                        '<div class="statistical-content__header-title"><img class="lazy" loading="lazy" src="' + escAttr(statsData.home_logo || '') + '" alt=""></div>' +
                        '<div class="statistical-content__header-title"><p class="title">Thống kê đội</p></div>' +
                        '<div class="statistical-content__header-title"><img class="lazy" loading="lazy" src="' + escAttr(statsData.away_logo || '') + '" alt=""></div>' +
                    '</div>' +
                '</div>';
            $container.append(headerHtml);
            $content = $container.find('.statistical-content');
        }

        // Remove old stat rows (keep header)
        $content.find('.statistical-content__row').remove();

        // Add new rows
        var rows = statsData.rows;
        for (var i = 0; i < rows.length; i++) {
            var r = rows[i];
            var rowHtml =
                '<div class="statistical-content__row">' +
                    '<div class="statistical-content__row-content"><span class="' + escAttr(r.home_class || 'content-normal') + '">' + escHtml(String(r.home_value)) + '</span></div>' +
                    '<div class="statistical-content__row-content"><p class="content-center">' + escHtml(r.label || '') + '</p></div>' +
                    '<div class="statistical-content__row-content"><span class="' + escAttr(r.away_class || 'content-normal') + '">' + escHtml(String(r.away_value)) + '</span></div>' +
                '</div>';
            $content.append(rowHtml);
        }
    }

    function escAttr(str) {
        return String(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // ────────────────────── Main Refresh Class ─────────────────────────

    function MatchDetailRefresh(config) {
        this.config = config || window.matchOddsRefresh || {};
        this.intervalId = null;
        this.isRefreshing = false;
        this.isLive = false;
    }

    MatchDetailRefresh.prototype.getInterval = function () {
        return this.isLive ? INTERVAL_LIVE : INTERVAL_DEFAULT;
    };

    MatchDetailRefresh.prototype.detectLiveState = function () {
        var $page = $('#match-detail-page');
        if ($page.length) {
            return $page.attr('data-is-live') === '1';
        }
        return false;
    };

    MatchDetailRefresh.prototype.refresh = function () {
        var self = this;
        if (self.isRefreshing) return;
        if (!self.config.ajaxUrl || (!self.config.apiFixtureId && !self.config.fixtureId)) return;

        self.isRefreshing = true;
        $.ajax({
            url: self.config.ajaxUrl,
            type: 'POST',
            data: {
                action: 'refresh_match_odds',
                nonce: self.config.nonce,
                api_fixture_id: self.config.apiFixtureId || self.config.fixtureId,
                fixture_id: self.config.fixtureId
            },
            success: function (response) {
                if (!response || !response.success || !response.data) return;

                var d = response.data;

                // Always update odds
                updateOddsDisplay(d.odds || d);

                // Update banner (score / status)
                if (d.banner) {
                    updateBanner(d.banner);

                    // Detect live state change → adjust interval
                    var wasLive = self.isLive;
                    self.isLive = !!d.banner.is_live;
                    if (wasLive !== self.isLive) {
                        self.restart();
                    }
                }

                // Update timeline & statistics (only sent when live/finished)
                if (d.timeline) {
                    updateTimeline(d.timeline);
                }
                if (d.statistics) {
                    updateStatistics(d.statistics);
                }
            },
            error: function (xhr, status, err) {
                if (typeof console !== 'undefined' && console.error) {
                    console.error('[MatchDetail Refresh] Error:', err);
                }
            },
            complete: function () {
                self.isRefreshing = false;
            }
        });
    };

    MatchDetailRefresh.prototype.start = function () {
        var self = this;
        self.stop();
        var ms = self.getInterval();
        self.intervalId = setInterval(function () {
            self.refresh();
        }, ms);
    };

    MatchDetailRefresh.prototype.restart = function () {
        this.start(); // stop + start with new interval
    };

    MatchDetailRefresh.prototype.stop = function () {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    };

    MatchDetailRefresh.prototype.init = function () {
        var self = this;
        if (!self.config.ajaxUrl) return;

        self.isLive = self.detectLiveState();

        // Start periodic refresh
        self.start();

        // Pause when tab hidden, resume when visible
        $(document).on('visibilitychange', function () {
            if (document.hidden) {
                self.stop();
            } else {
                // Refresh immediately then restart timer
                self.refresh();
                self.start();
            }
        });
    };

    MatchDetailRefresh.prototype.destroy = function () {
        this.stop();
    };

    // ────────────────────────── Bootstrap ──────────────────────────────

    $(function () {
        if (typeof matchOddsRefresh === 'undefined') return;
        window.matchOddsRefreshInstance = new MatchDetailRefresh(matchOddsRefresh);
        window.matchOddsRefreshInstance.init();
    });
})(jQuery);
